<template>
  <div class="snackbar">
    <div>{{ $t('report-download-error-pre') }}
      <a href="javascript:window.location.reload()"> {{ $t('report-download-error-reload') }} </a>
      {{ $t('report-download-error-post') }}
    </div>
  </div>
</template>

<style lang="scss">
.snackbar {
  body:not(.show-snackbar) & {
    display: none;
  }

  position: fixed;
  bottom: 100px;
  z-index: 1000;
  width: 100%;

  > div {
    color: #ffffff;
    background-color: #000000;
    max-width: 600px;
    width: 100%;
    text-align: center;
    margin: 0 auto;
    padding: 20px;
    border-radius: 4px;
  }
}

</style>
